export default __webpack_public_path__ + "static/media/share-tw.fea23322.svg";